import React from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import style from './TopHeader.scss';
import { XButton } from '../XButton/XButton';

export const TopHeader = () => {
    const t = usePortletTranslations();

    return (
        <div className={style.wrapper}>
            <div className={style.promotions}>{t('promotions')}</div>
            <XButton/>
        </div>
    );
};
